import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidMobilePhoneNumber, isValidPhoneNumber } from '../helpers/phone-validation.helper';

export function PhoneValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  return isValidPhoneNumber(control.value) ? null : { phoneInvalid: true };
}

export function MobilePhoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    return isValidMobilePhoneNumber(control.value) ? null : { mobilePhoneInvalid: true };
  };
}
